<template>
  <div class="card-mission"
       :class="[ type, { 'isWrite': write } ]"
       :style="{ 'background' : card.background }"
       @click="$emit('click')">
    <template v-if="type">
      <span class="card-mission-subtitle" :class="card.subTitleClass"
            v-text="card.subTitle"
      />
      <h3 class="card-mission-title" v-text="card.label" />
      <div class="card-mission-img">
        <WeatherNew :icon="card.icon" />
      </div>
    </template>
    <v-overlay :value="busy" absolute opacity="0.3">
      <v-progress-circular
          size="20"
          color="white"
          indeterminate
      />
    </v-overlay>
  </div>
</template>

<script>
const WEATHER = () => {
  return {
    DEFAULT: {
      subTitle: '내 마음날씨는 어떨까요?',
      subTitleClass: ['text--secondary'],
      label: '마음날씨',
      icon: 'mindWeather',
      background: 'linear-gradient(131.18deg, #FFFFFF 26.67%, #715FFD 471.38%)'
    },
    WEATHER_01: {
      subTitle: '오늘 내 마음 날씨',
      subTitleClass: [],
      label: '맑음',
      icon: 'weather01',
      background: 'linear-gradient(131.18deg, #FFFFFF 26.67%, #FF6D00 471.38%)'
    },
    WEATHER_02: {
      subTitle: '오늘 내 마음 날씨',
      subTitleClass: [],
      label: '보통',
      icon: 'weather02',
      background: 'linear-gradient(131.18deg, #FFFFFF 26.67%, #FF6D00 471.38%)'
    },
    WEATHER_03: {
      subTitle: '오늘 내 마음 날씨',
      subTitleClass: [],
      label: '구름',
      icon: 'weather03',
      background: 'linear-gradient(131.18deg, #FFFFFF 26.67%, #FF6D00 471.38%)'
    },
    WEATHER_04: {
      subTitle: '오늘 내 마음 날씨',
      subTitleClass: [],
      label: '흐림',
      icon: 'weather04',
      background: 'linear-gradient(133.19deg, #FFFFFF 25.79%, #11545B 233.71%)'
    },
    WEATHER_05: {
      subTitle: '오늘 내 마음 날씨',
      subTitleClass: [],
      label: '태풍',
      icon: 'weather05',
      background: 'linear-gradient(133.1deg, #FFFFFF 25.83%, #000000 351.91%)'
    }
  }
}
const MINDNOTE = () => {
  return {
    DEFAULT: {
      subTitle: '오늘 내 마음을 기록해요',
      subTitleClass: ['text--secondary'],
      label: '마음노트',
      icon: 'mindNote',
      background: 'linear-gradient(135.19deg, #FFFFFF 24.92%, #A0C0F0 348.93%)',
    },
    COMPLETE: {
      subTitle: '나를 위한 생각과 다짐',
      subTitleClass: ['text--secondary'],
      label: '작성 완료',
      icon: 'mindNoteComplete',
      background: 'linear-gradient(135.19deg, #FFFFFF 24.92%, #3E7BD7 348.93%)',
    }
  }
}
export default {
  name: 'MissionCard',
  props: {
    busy: {}, // 로딩중
    type: {}, // weather, note
    typeCode: {}, // weather
    write: {} // 작성 상태
  },
  computed: {
    card () {
      console.log(this.$props)
      // 작성 완료 유무
      if (this.type === 'weather') {
        if (this.write && this.typeCode) return WEATHER()[this.typeCode]
        return WEATHER().DEFAULT
      } else if (this.type === 'mindnote') {
        if (this.write) return MINDNOTE().COMPLETE
        return MINDNOTE().DEFAULT
      } else {
        return {
          background: 'linear-gradient(135.19deg, #FFFFFF 24.92%, #A0C0F0 348.93%)'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
